import { ActionType } from "../types";
import { Roles, RolesAction } from "../types/roles";

export const roles = (state: Roles = {}, action: RolesAction): Roles => {
  switch (action.type) {
    case ActionType.GET_ROLES_REQUEST:
      return {
        ...state,
        [action.key]: null,
      };
    case ActionType.GET_ROLES_SUCCESS:
      return {
        ...state,
        [action.key]: action.roles,
      };
    case ActionType.GET_ROLES_FAILURE:
      return {
        ...state,
        [action.key]: null,
      };
    default:
      return state;
  }
};
